import React, {useState} from "react";

export function SearchBar({keyword, handleKeyword}) {
  const [searchValue, setSearchValue] = useState();

  const handleSentValue = (event) => {
    event.preventDefault();
    handleKeyword(searchValue);
  };

  return (
    <form className="search__form">
      <label className="search__form-label">
        <span className="a11y">Search</span>
        <input
          type="search"
          className="search__form-input"
          placeholder="Enter keywords"
          autoComplete="off"
          title="Search" autoFocus="autoFocus"
          aria-label="Enter search keywords"
          onChange={(e) => setSearchValue(e.target.value)}
          autoFocus={ false }
          defaultValue={keyword}
        />
        <button type="submit" className="search__form-submit" aria-label= "search icon" onClick={handleSentValue}>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" role="img"
               focusable="false" className="svg svg--search">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M11.7373 4.88208C7.87131 4.88208 4.7373 8.01609 4.7373 11.8821C4.7373 15.7481 7.87131 18.8821 11.7373 18.8821C15.6033 18.8821 18.7373 15.7481 18.7373 11.8821C18.7373 8.01609 15.6033 4.88208 11.7373 4.88208ZM2.7373 11.8821C2.7373 6.91152 6.76674 2.88208 11.7373 2.88208C16.7079 2.88208 20.7373 6.91152 20.7373 11.8821C20.7373 16.8526 16.7079 20.8821 11.7373 20.8821C6.76674 20.8821 2.7373 16.8526 2.7373 11.8821Z"
                  fill="black">
            </path>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M16.6806 16.8249C17.0711 16.4344 17.7043 16.4344 18.0948 16.8249L22.4448 21.1749C22.8353 21.5654 22.8353 22.1986 22.4448 22.5891C22.0543 22.9796 21.4211 22.9796 21.0306 22.5891L16.6806 18.2391C16.2901 17.8486 16.2901 17.2154 16.6806 16.8249Z"
                  fill="black">
            </path>
          </svg>
        </button>
      </label>
    </form>
  );
}
